import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./screens/Home";
import Services from "./screens/Services";
import Doctors from "./screens/Doctors";
import Gallery from "./screens/Gallery";
import Appointment from "./screens/Appointment";
import About from "./screens/About";

function App() {
  return (
    <Router>
      <Header />
      <main className="mainContainer">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/doctors" element={<Doctors />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/appointment" element={<Appointment />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
